<template>
  <div class="filter-section">
    <div class="wrapper">

      <div class="filters" ref="filters">
        <a
          class="close"
          v-on:click="closeFilters"
        >
          <simple-svg
            :filepath="'/static/svg/close.svg'"
            :fill="'#ffffff'"
          />
        </a>

        <h2 class="filter-title" ref="filterTitle">Organise your view of our Life’s Moments data using the categories below.</h2>

        <timeline-filter
          name="Age"
          v-bind:items="content.age"
          ref="ageSel"
          class="timeline-filter"
        ></timeline-filter>

        <timeline-filter
          name="Region"
          v-bind:items="content.region"
          ref="regionSel"
          class="timeline-filter"
        ></timeline-filter>

        <timeline-filter
          name="Sex"
          v-bind:items="content.sex"
          ref="sexSel"
          class="timeline-filter"
        ></timeline-filter>

        <timeline-filter
          name="Income"
          v-bind:items="content.income"
          ref="incomeSel"
          class="timeline-filter"
        ></timeline-filter>

        <timeline-filter
          name="Industry"
          v-bind:items="content.industry"
          ref="industrySel"
          class="timeline-filter"
        ></timeline-filter>
      </div>
      <a class="reset" v-on:click="handleReset">Reset all</a>
    </div>
  </div>
</template>

<script>
import { Bus } from '@/components/Bus'
import TimelineFilter from '@/components/Filter'
import data from '@/data/data.json'
import { TweenMax, Power1 } from 'gsap'

export default {
  name: 'Filters',
  components: {
    'timeline-filter': TimelineFilter
  },
  data () {
    return {
      content: data.filters,
      active: ''
    }
  },
  methods: {
    closeFilters: function () {
      this.$refs.filters.classList.remove('open')
    },
    handleReset: function () {
      this.$store.commit('resetFilters')
      this.$store.dispatch('applyFilters')

      Bus.$emit('redrawMarkers')
    }
  },
  computed: {
    activeFilters: function () {
      return this.$store.getters.getFilters
    }
  },
  mounted: function () {
    Bus.$on('openFilter', () => {
      this.$refs.filters.classList.add('open')
    })

    let filter = document.getElementsByClassName('timeline-filter')
    let filterTitle = this.$refs.filterTitle

    TweenMax.set(filter, {
      opacity: 0,
      y: '+=10px'
    })

    TweenMax.set(filterTitle, {
      opacity: 0
    })

    TweenMax.to(filterTitle, 0.4, {
      opacity: 1,
      delay: 1,
      ease: Power1.easeInOut
    })

    TweenMax.staggerTo(filter, 0.8, {
      opacity: 1,
      y: '-=10px',
      delay: 1.4,
      ease: Power1.easeInOut
    }, 0.1)
  }
}
</script>

<style lang="scss" scoped>

@import '../styles/core/vars.scss';
@import '../styles/core/mixins.scss';

.filter-section {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  pointer-events: none;

  @include respond-to('medium') {
    position: absolute;
    bottom: 40px;
    width: 100%;
    padding: 0;
    left: 0;
  }

  @media screen and (max-height: 820px) {
    position: relative;
    left: 0;
    top: 0;
  }

  @media screen and (max-width: 767px) and (max-height: 820px) {
    position: absolute;
    width: 100%;
    z-index: 10;
  }

  h2 {
    text-transform: none;
    font-size: 18px;
    margin: 30px 0 5px;
  }

}

.filter-title {
  display: block;
  width: 100%;
  // opacity: 0;
  text-align: center;
  color: $c-pink;
  padding: 20px 40px;

  @include respond-to('medium') {
    color: $c-white;
    padding: 0;
  }
}

.close {
  display: block;

  @include respond-to('medium') {
    display: none;
  }
}

.filters {
  // display: none;
  // position: absolute;
  // top: 0;
  // left: 0;
  // margin: 20px;
  padding: 30px 20px 20px;
  background-color: $c-white;
  border-radius: 25px;
  opacity: 0;
  pointer-events: none;
  transition: all 0.2s ease-in-out;
  // overflow: hidden;
  z-index: 10;

  &.open {
    opacity: 1;
    pointer-events: auto;
  }

  @include respond-to('medium') {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    flex-wrap: wrap;
    margin: 0;
    left: 0;
    width: 100%;
    position: relative;
    background-color: transparent;
    opacity: 1;
    pointer-events: auto;
    padding: 0;
  }

  &__title {
    opacity: 0;
  }
}

.reset {
  color: $c-white;
  font-family: $f-body;
  text-decoration: underline;
  margin-top: 20px;
  display: none;
  text-align: center;
  cursor: pointer;
  pointer-events: auto;

  @include respond-to('medium') {
    display: inline-block;
  }

  @media screen and (max-height: 820px) {
    display: none;
  }
}

.filter {
  // opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Filters.vue